import React, { useEffect, useState } from 'react';
import './index.css';
import { SolicitationView } from '../../../../models/SolicitationView';
import LcIcon from '../../../Generic/LcIcon';
import moment from 'moment';
import Parse from 'html-react-parser';
import LcIconLink from '../../../Generic/LcIconLink';
import AproveWork from '../../../../pages/Attendance/WorkList/AproveWork';
import WorkService from '../../../../services/WorkService/WorkService';
import { WorkView } from '../../../../models/WorkView';
import SideModal from '../../SideModal/SideModal';
import LcLoading from '../../../Generic/LcLoading';
import { RootState } from '../../../../store';
import { UserState } from '../../../../store/reducers/userReducer';
import { useSelector, useDispatch } from 'react-redux';
import UserService from '../../../../services/HeyHoUserService/HeyHoUserService';
import CancelWork from '../../../../pages/Attendance/WorkList/CancelWork';
import TextTools from '../../../../services/TextTools/TextTools';


interface Props {
    massiveSolicitation: SolicitationView[],
    aproveAttendant: SolicitationView[],
    aproveSolicitation: SolicitationView[],
    getAproval: Function,
    closed: Function
}

const Pendencies: React.FC<Props> = (props) => {
    const user = useSelector<RootState, UserState>(state => state.user);
    const workService = new WorkService(props);
    const userService: UserService = new UserService(props);
    const textTools = new TextTools();
    const [workAproveReprove, setWorkAproveReprove] = useState<WorkView>();
    const [aproveSolicitation, setAproveSolicitation] = useState<SolicitationView>();
    const [typeAprove, setTypeAprove] = useState<number>(8);
    const [typeCancel, setTypeCancel] = useState<number>(5);
    const [modalAprove, setModalAprove] = useState<boolean>(false);
    const [modalAproveDetails, setModalAproveDetails] = useState<boolean>(false);
    const [detailsAprovalId, setDetailsAprovalId] = useState<number>(0);
    const [detailsAprovalSelected, setDetailsAprovalSelected] = useState<SolicitationView>();
    const [loading, setLoading] = useState<boolean>(false);
    const [loadingRow, setLoadingRow] = useState<number>();
    const [teamManagerList, setTeamManagerList] = useState<any[]>([]);
    const [cancelWork, setCancelWork] = useState<any>();

    const getManagerByWorkTeamList = async (workListLocal: any[]) => {
        try {
            const workTeamList = workListLocal.map((work: any) => work.workGroupId);
            const response = await userService.GetWorkTeamManagerByWorkTeamList(workTeamList);

            var _list: any[] = [];

            workListLocal.map((work: any) => {
                var workTeamList: any = response.data[work.workGroupId];
                var listaRetorno = workTeamList.filter((x: any) => x === user.id);
                if (listaRetorno.length > 0) {
                    _list.push(work.id);
                }
            })

            setTeamManagerList(_list);
        }
        catch (error) {
            debugger
        }
    }

    useEffect(() => {
        if (window.location.pathname === "/") {
            getManagerByWorkTeamList(props.aproveSolicitation);
        }
        else {
            getManagerByWorkTeamList(props.aproveAttendant);
        }
    }, [])

    const getAproveRepoveWork = async (solicitation: SolicitationView, idWork: number, type: number) => {
        setLoading(true);
        setLoadingRow(solicitation.idWork);

        try {
            let list = await workService.getWorkViewbySolicitation(solicitation.id);
            let aproveReproveWorks = list.filter(work => work.id === idWork);
            setWorkAproveReprove(aproveReproveWorks[0]);
        }
        catch (error: any) {
            console.error(error);
        }

        setTypeAprove(type);
        setAproveSolicitation(solicitation);

        setModalAprove(true);
        setLoadingRow(0);
        setLoading(false);
    }

    const getWorkBySolicitationId = async (solicitation: any) => {
        setLoading(true);
        setLoadingRow(solicitation.idWork);

        try {
            let list = await workService.getWorkViewbySolicitation(solicitation.id);
            let aproveReproveWorks = list.filter(work => work.id === solicitation.idWork);
            setCancelWork(aproveReproveWorks[0]);
            setSelectedRow(solicitation);
        }
        catch (error: any) {
            console.error(error);
        }

        setLoadingRow(0);
        setLoading(false);
    }

    useEffect(() => {
        let filter = props.aproveAttendant.filter(aprove => aprove.id === detailsAprovalId);
        setDetailsAprovalSelected(filter[0]);
    }, [detailsAprovalId])

    const handleAproveReprove = (aproved: SolicitationView, work: number, type: number) => {
        // if (window.screen.width > 600) {
        getAproveRepoveWork(aproved, work, type);
        // }
        // else {
        //     setDetailsAprovalId(aproved.id);
        //     setModalAproveDetails(true);
        // }
    }

    useEffect(() => {
        if (props.aproveAttendant.length === 0 && props.massiveSolicitation.length === 0 && props.aproveSolicitation.length === 0) {
            props.closed(false);
        }
    }, [props.aproveAttendant, props.massiveSolicitation, props.aproveSolicitation]);

    const [selectedRow, setSelectedRow] = useState<any>();

    return (
        <div className='pendencies'>
            {
                window.location.pathname !== '/' && props.massiveSolicitation.length > 0 &&
                <div className="massiveSolicitation">
                    <div className='headerMassive'>
                        <LcIcon icon={'ppi ppi-exclamation'} color={'#E64646'} />
                        <h3>Problema massivo</h3>
                    </div>
                    {
                        props.massiveSolicitation.map(massive => {
                            return (
                                <div key={massive.id} className="cardMassive">
                                    <a className='solicitationNumber' href={`${window.location.pathname}/${massive.id}`} style={{ display: "flex" }}>
                                        <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", display: "block", maxWidth: "80%" }}>{massive.subject}</span>
                                        : {massive.id}
                                    </a>
                                    <p className='time' >{(moment(massive.registrationDate).fromNow())};</p>
                                    <br />
                                    <p className='details'>{Parse(textTools.cleanDetails(massive.details))} </p>
                                </div>
                            )
                        })
                    }
                </div>
            }
            {
                (window.location.pathname !== '/')
                    ? props.aproveAttendant.length > 0 &&
                    <div className="aprovePendencies">
                        <h3>Aprovações pendentes</h3>
                        {
                            props.aproveAttendant.map(aprove => {
                                return (
                                    <div key={aprove.id} className="cardAprove">
                                        <LcLoading loading={loading && loadingRow == aprove.idWork}>
                                            <div className='hearderAprove'>
                                                <div>
                                                    <a href={`${window.location.pathname}/${aprove.id}`} style={{ display: "flex" }}>
                                                        <span style={{ textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap", display: "block", maxWidth: "80%" }}>{aprove.subject}</span>
                                                        : {aprove.id}
                                                    </a>
                                                    <p className='time' >{(moment(aprove.registrationDate).fromNow())}</p>
                                                </div>
                                                <div className='btnAprove'>
                                                    <LcIconLink
                                                        icon={'ppi ppi-thumb-up'}
                                                        tooltip={"Aprovar trabalho"}
                                                        color={'#00d500'}
                                                        onClick={() => getAproveRepoveWork(aprove, aprove.idWork, 7)}
                                                    />
                                                    <LcIconLink
                                                        icon={'ppi ppi-thumb-down'}
                                                        tooltip={"Reprovar trabalho"}
                                                        color={"#E64646"}
                                                        onClick={() => getAproveRepoveWork(aprove, aprove.idWork, 8)}
                                                    />
                                                    {
                                                        teamManagerList && teamManagerList.length > 0 && teamManagerList.includes(aprove.id) &&
                                                        <LcIconLink icon={"ppi ppi-x"} onClick={() => { getWorkBySolicitationId(aprove) }} tooltip={"Cancelar trabalho"} />
                                                    }
                                                </div>
                                            </div>
                                            <p className='details'>{Parse(textTools.cleanDetails(aprove.details))}</p>
                                        </LcLoading>
                                    </div>
                                )
                            })
                        }
                    </div>
                    : props.aproveSolicitation.length > 0 &&
                    <div className="aprovePendencies">
                        <h3>Aprovações pendentes</h3>
                        {
                            props.aproveSolicitation.map(aprove => {
                                return (
                                    <div key={aprove.id} className="cardAprove">
                                        <LcLoading loading={loading && loadingRow == aprove.idWork}>
                                            <div className='hearderAprove'>
                                                <div>
                                                    <a href={`Attendance/${aprove.id}`} style={{ pointerEvents: (window.screen.width < 600) ? 'none' : 'auto' }}>
                                                        <span>{aprove.subject}</span>
                                                        : {aprove.id}
                                                    </a>
                                                    <p className='time'>{(moment(aprove.registrationDate).fromNow())}</p>
                                                </div>
                                                <div className='btnAprove'>
                                                    <LcIconLink
                                                        icon={'ppi ppi-thumb-up'}
                                                        tooltip={"Aprovar trabalho"}
                                                        color={'#00d500'}
                                                        onClick={() => handleAproveReprove(aprove, aprove.idWork, 7)}
                                                    />
                                                    <LcIconLink
                                                        icon={'ppi ppi-thumb-down'}
                                                        tooltip={"Reprovar trabalho"}
                                                        color={"#E64646"}
                                                        onClick={() => handleAproveReprove(aprove, aprove.idWork, 8)}
                                                    />
                                                    {
                                                        teamManagerList && teamManagerList.length > 0 && teamManagerList.includes(aprove.id) &&
                                                        <LcIconLink icon={"ppi ppi-x"} onClick={() => { getWorkBySolicitationId(aprove) }} tooltip={"Cancelar trabalho"} />
                                                    }
                                                </div>
                                            </div>
                                            {Parse(textTools.cleanDetails(aprove.details))}
                                        </LcLoading>
                                    </div>
                                )
                            })
                        }
                    </div>
            }
            {
                workAproveReprove && aproveSolicitation &&
                <AproveWork
                    work={workAproveReprove}
                    solicitation={aproveSolicitation}
                    onCloseEvent={(e) => {
                        setModalAprove(false);
                        props.getAproval();
                    }}
                    type={typeAprove}
                    open={modalAprove}
                    content={''}
                    confirmMessage={''}
                    abortMessage={''}
                />
            }
            {
                cancelWork &&
                <CancelWork
                    work={cancelWork}
                    solicitation={selectedRow}
                    onCloseEvent={(e) => {
                        setCancelWork(undefined);
                        setSelectedRow(undefined);
                        props.getAproval();
                    }}
                    open={cancelWork}
                    content={''}
                    confirmMessage={''}
                    abortMessage={''}
                />
            }

            {/* <SideModal visible={workAproveReprove != undefined && aproveSolicitation != undefined} header={'Detalhes'} onClose={() => setModalAproveDetails(false)}>
                {
                    detailsAprovalSelected &&
                    <div className="details">
                        <h4 > {detailsAprovalSelected.subject} </h4>
                        <hr />
                        {Parse(detailsAprovalSelected.details)}
                        <hr />
                        <div className='btnGroupAprove'>
                            <button className='btn' onClick={() => getAproveRepoveWork(detailsAprovalSelected, detailsAprovalSelected.idWork, 7)}>
                                Aprovar
                                <LcIconLink
                                    icon={'ppi ppi-check'}
                                    tooltip={"Aprovar trabalho"}
                                />
                            </button>
                            <button className='btn' onClick={() => getAproveRepoveWork(detailsAprovalSelected, detailsAprovalSelected.idWork, 8)} >
                                Reprovar
                                <LcIconLink
                                    icon={'ppi ppi-x'}
                                    tooltip={"Reprovar trabalho"}
                                />
                            </button>

                        </div>
                    </div>
                }
            </SideModal> */}
        </div>
    );
}

export default Pendencies;